import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpHeaders,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";

import { tap, catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  expiresInTimer: any;
  accessTokenExpiry: number;
  authToken: string;
  authReq: HttpRequest<any>;
  // url = environment.serverUrl;
  url: any;

  constructor(private router: Router) {
    // const env =  localStorage.getItem('environment');
    // if (env === 'Dev Env') {
    //   localStorage.getItem('environment') = environment.serverUrl;
    //   console.log(localStorage.getItem('environment'));
    // }
    // if (env === 'Demo Env') {
    //   localStorage.getItem('environment') = environment.serverUrl1;
    //   console.log(localStorage.getItem('environment'));
    // }
    // if (env === 'Pilot Env') {
    //   localStorage.getItem('environment') = environment.serverUrl2;
    //   console.log(localStorage.getItem('environment'));
    // }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    console.log(req.url, localStorage.getItem('IPFSurl'))
    if (
      (req.url !== `${environment.apiUrl}${environment.login}` &&
        req.url !== `${environment.apiUrl}${environment.forgotpassword}`
        &&
        req.url !== `${environment.apiUrl}${environment.loginOTPVerify}`

        &&
        req.url !== `${environment.apiUrl}${environment.validOTP}`
        &&
        req.url !== `https://ipv4.myexternalip.com/json`
        &&
        req.url !== `${environment.hashUrl}$:444/api`
        &&
        req.url !== `${environment.hashUrl}$:444/api/download`
        &&
        req.url !== `${environment.apiUrl}${environment.downLoadFile}`


        && req.url !== `${environment.apiUrl}${environment.IPWhitelist}` &&
        localStorage.getItem('IPFSurl') != req.url
      )

    ) {
      const authToken = localStorage.getItem("authToken");

      req = req.clone({
        headers: req.headers.set(`authorization`, authToken),
      });
    }
    return next.handle(req).pipe(
      tap((success) => {
        console.log(success);
        if (success instanceof HttpResponse) {
          console.log(success);
          if (
            req.url !== `${environment.apiUrl}${environment.login}` ||
            req.url !== `${environment.apiUrl}${environment.forgotpassword}`
            ||
            req.url !== `${environment.apiUrl}${environment.loginOTPVerify}`
            // ||       req.url !== `${environment.apiUrl}${environment.updatePassword}`
            || req.url !== `${environment.apiUrl}${environment.validOTP}`
            ||
            req.url !== `https://ipv4.myexternalip.com/json`
            || req.url !== `${environment.apiUrl}${environment.IPWhitelist}`
            ||
            localStorage.getItem('IPFSurl') != req.url
            ||
            req.url !== `${environment.hashUrl}$:444/api`
            ||
            req.url !== `${environment.hashUrl}$:444/api/download`
            ||
            req.url !== `${environment.apiUrl}${environment.downLoadFile}`


          ) {

            if (
              success &&
              success["body"] &&
              (success["body"].responseCode === 401 ||
                success["body"].responseCode === 602 ||
                success["body"].responseCode === 603 ||
                success["body"].responseCode === 403)

            ) {
              console.log(success['body'])
              localStorage.clear();
              this.router.navigate(["sign-in"]);
            } else {

            }
          }
        }
      }),
      //tap(success => {
      //   // Do your success stuff in here
      //   // console.log(success['body'].responseCode ===  1 && success['body'].responseData  === "Invalid Token"
      //   // )
      //   if(req.url !== `${environment.apiUrl}${environment.login}`){

      //   } else {
      //     if(success && success['body'] && success['body'].responseCode ===  1 && success['body'].responseData  === "Invalid Token"){
      //               this.router.navigate(['sign-in']);
      //     }
      //   }
      // }),

      catchError((err) => {
        console.log(err);
        // tslint:disable-next-line: no-conditional-assignment
        // if (err.error.error === "invalid_token") {
        //   // this.authService.refreshToken();
        // }
        // // tslint:disable-next-line: no-conditional-assignment
        // if (err.error.error === "invalid_grant") {
        //   // this.authService.logout();
        // }
        // if (err.error.error_description === "Invalid refresh token: null") {
        //   // this.authService.logout();
        // }
        return throwError(err);
      })
    );
  }
}
